import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import toast, { Toaster } from 'react-hot-toast';

import clsx from 'clsx';

import { AppDispatch } from '../../../redux/reducer/store';
import {
  actionGetVacancies,
  actionVacanciesFilters,
} from '../../../redux/action/recruiting/actionVacancy';
import {
  reducerSelectedVacanciesId,
  reducerSelectedVacancies,
  reducerVacancyStatus,
  reducerVacancyListInputValues,
  reducerVacancyMultiselect,
  reducerGetVacancyList,
} from '../../../redux/reducer/recruiting/reducers/reducerVacancy';
import { actionGetProjectsList } from "../../../redux/action/projects/actionProjects";

import { reducerSetVacantCheckboxes } from '../../../redux/reducer/projects/reducers/reducerVacantRoutesList';
import { generateStyles } from '../../../utils/generateToastStyles';

import { formatDateWithDots } from '../../../utils/formatDate';
import { formatReports } from '../../../utils/formatReports';

import Loader from '../../custom/loader/loader';
import CustomMultiSelect from '../../custom/customMultiSelect/customMultiSelect';
import Select from '../../custom/select/select';
import RangeDatePicker from '../../custom/rangeDatePicker/rangeDatePicker';
import Pagination from '../../pagination/pagination';
import LimitSelect from '../../custom/limitSelect/limitSelect';
import ToastPopup from '../../custom/toastPopup/toastPopup';

import { IVacancyListOptions } from '../../../types/vacancyInterfeces';

import '../../table/table.scss';
import styles from '../../table/recruiting/recruiting.module.scss';
import { IUserOptions } from '../../../types/interfaces';

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const booleanOptions = [
  { value: 'all', label: 'Все' },
  { value: 'yes', label: 'Да' },
  { value: 'no', label: 'Нет' },
];
const ReinstateAnEmployeeSection: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const {
    data,
    limit,
    page,
    count,
    checkboxes,
    selectedVacanciesId,
    clientsStatus,
    clientsStatusMessage,
    vacancyListSettings,
    vacancyListInputValues,
    modifiedDate,
    createDate,
    filters,
  } =
    useSelector((state: any) => state.recruiting.vacancyList);
  const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

  const requestStatusOptions = [
    {
      status: 400,
      errorMessage: clientsStatusMessage,
    },
    {
      status: 200,
      successMessage: 'Вакансия создана!',
    },
    {
      status: 500,
      errorMessage: 'Ошибка на стороне сервера',
    },
    {
      status: 2,
      errorMessage: 'Выберите проект',
    },
    {
      status: 3,
      errorMessage: 'Выберите маршрут',
    },
    {
      status: 0,
      successMessage: clientsStatusMessage,
    },
  ];
  const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] =
    useState<boolean>(false);
  const [isCheckedRows, setIsCheckedRows] = useState<boolean[]>(checkboxes);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);
  const [isInputChange, setIsInputChange] = useState<boolean>(false);
  const [isPending, setIsPending] = useState<boolean>(false);
  const actualLimit =
    JSON.parse(localStorage.getItem('pageLimit') as string) || limit;

  const checkboxList = (check: boolean) => {
    const updatedCheckedRows =
      data &&
      data.reduce((acc: boolean[], vacancy: IVacancyListOptions) => {
        const vacancyId = vacancy.vacancy.value?.id;
        acc[vacancyId] = check;
        return acc;
      }, {});
    dispatch(reducerSelectedVacanciesId(formatReports(updatedCheckedRows)));
    setIsCheckedRows(updatedCheckedRows);
  };

  useEffect(() => {
    if (selectedVacanciesId && !selectedVacanciesId.length) {
      setIsCheckedRows(data && checkboxes);
      setIsHeaderCheckboxChecked(false);
    }
  }, [checkboxes, data, selectedVacanciesId]);

  useEffect(() => {
    if (data) {
      checkboxList(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (isHeaderCheckboxChecked && data) {
      checkboxList(isHeaderCheckboxChecked);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHeaderCheckboxChecked, data]);

  const handleHeaderCheckboxChange = () => {
    setIsHeaderCheckboxChecked(!isHeaderCheckboxChecked);
    if (isHeaderCheckboxChecked) {
      checkboxList(false);
    }
  };
  const handleRowCheckboxChange = (el: IVacancyListOptions) => {
    const vacancyId = el.vacancy.value.id;
    setIsCheckedRows((prevCheckedRows: boolean[]) => ({
      ...prevCheckedRows,
      [vacancyId]: !prevCheckedRows[vacancyId],
    }));
    const updatedSelectedVacancies = formatReports({
      ...isCheckedRows,
      [vacancyId]: !isCheckedRows[vacancyId],
    });
    dispatch(reducerSelectedVacanciesId(updatedSelectedVacancies));
    dispatch(reducerSelectedVacancies(el));
    setIsHeaderCheckboxChecked(updatedSelectedVacancies.length === data.length);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (value === '') {
      const updatedInputValues = { ...vacancyListInputValues };
      if (name === 'id') {
        delete updatedInputValues.vacancy;
      } else {
        delete updatedInputValues[name];
      }
      dispatch(reducerVacancyListInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacancyListInputValues({
          ...vacancyListInputValues,
          ...(name === 'routes' ? { [name]: [value] } : name === 'id' ? { vacancy: [{ id: value }] } : { [name]: value })
        })
      );
    }
    setIsInputChange(true);
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setIsPending(true);
      dispatch(actionGetVacancies(limit, page)).then(() => {
        setIsPending(false);
      });
      setIsInputChange(false);
      resetPages();
    }
  };
  const selectChange = (event: { value: string, label: string }, name: string) => {
    const value = event.value;
    if (value === '') {
      const updatedInputValues = { ...vacancyListInputValues };
      delete updatedInputValues[name];
      dispatch(reducerVacancyListInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacancyListInputValues({
          ...vacancyListInputValues,
          [name]: value === 'all' ? null : value === 'yes',
        })
      )
      setIsInputChange(true);
    }
  };
  const handleChange = (newLimit: number, newPage: number) => {
    setIsPending(true);
    dispatch(actionGetVacancies(newLimit, newPage)).then(() => {
      setIsPending(false);
    });
    localStorage.setItem('pageLimit', JSON.stringify(newLimit));
  };
  const handleFromFilter = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
    const value = event.target.value;
    if (value === '') {
      const updatedInputValues = { ...vacancyListInputValues };
      updatedInputValues[name] = { ...vacancyListInputValues[name], from: null };
      dispatch(reducerVacancyListInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacancyListInputValues({
          ...vacancyListInputValues,
          [name]: { ...vacancyListInputValues[name], from: parseFloat(value) },
        })
      );
    }
    setIsInputChange(true);
  }
  const handleToFilter = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
    const value = event.target.value;
    if (value === '') {
      const updatedInputValues = { ...vacancyListInputValues };
      updatedInputValues[name] = { ...vacancyListInputValues[name], to: null };
      dispatch(reducerVacancyListInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacancyListInputValues({
          ...vacancyListInputValues,
          [name]: { ...vacancyListInputValues[name], to: parseFloat(value) },
        })
      );
    }
    setIsInputChange(true);
  }

  const resetPages = () => {
    setCurrentPage(1);
    setStartPage(1);
  };
  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 1);
    resetPages();
  };
  useEffect(() => {
    setIsPending(true);
    dispatch(actionGetVacancies(actualLimit, page)).then(() => {
      setIsPending(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    requestStatusOptions.forEach((option: { status: number, successMessage?: string, errorMessage?: string }) => {
      if (clientsStatus === option.status) {
        toast.dismiss();
        toast(
          t => (
            <ToastPopup
              title={
                option.successMessage
                  ? option.successMessage
                  : option.errorMessage
              }
              isSuccess={option.successMessage ? true : false}
              toast={toast}
              t={t}
            />
          ),
          generateStyles(option.successMessage ? true : false)
        );
      }
    });

    setTimeout(() => {
      dispatch(reducerVacancyStatus(null));
    }, 5000);
    // eslint-disable-next-line
  }, [dispatch, clientsStatus]);
  useEffect(() => {
    const handleDocumentClick = (event: React.ChangeEvent<HTMLInputElement> | Event): void => {
      const inputEvent = event as React.ChangeEvent<HTMLInputElement>;
      const touchedInputs = ['salary', 'revenue'];
      if (!touchedInputs.includes(inputEvent.target.name) && isInputChange) {
        setIsPending(true);
        dispatch(actionGetVacancies(limit, page)).then(() => {
          setIsPending(false);
        });
        setIsInputChange(false);
        resetPages();
      }
    };
    if (isInputChange) {
      document.addEventListener('click', handleDocumentClick);
      return () => {
        document.removeEventListener('click', handleDocumentClick);
      };
    } else
      return () => {
        document.removeEventListener('click', handleDocumentClick);
      };
  }, [dispatch, isInputChange, limit, page]);
  useEffect(() => {
    dispatch(actionVacanciesFilters())
  }, [dispatch]);

  useEffect(() => {
    dispatch(reducerGetVacancyList({ data: [] }))
  }, [dispatch])

  useEffect(() => {
    dispatch(reducerSetVacantCheckboxes([]));
    dispatch(actionGetProjectsList(actualLimit, page))
    dispatch(reducerVacancyListInputValues({ ...vacancyListInputValues, projects: [] }));
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <div>
        <div className='loader__wrapper'>
          {(isPending) && <Loader />}
        </div>

        <div
          className={clsx(
            JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
            isOpenSidebar &&
            'active__table',
            !isOpenSidebar && 'closed__table',
            'table'
          )}
        >
          {(clientsStatus && clientsStatus !== null) && <Toaster
            position='top-center'
            toastOptions={{
              duration: 5000,
            }}
          />}
          <div className='table__wrapper table__wrapper-application'>
            <table>
              <thead className='table__header'>
                <tr>
                  <th className='reports__checkbox_block'>
                    {(claims.includes('admin') || claims.includes('recruiting:vacancy:export') || claims.includes('recruiting:vacancy:edit')) &&
                      <input
                        onChange={handleHeaderCheckboxChange}
                        checked={isHeaderCheckboxChecked}
                        type='checkbox'
                      />}
                  </th>

                  {vacancyListSettings.includes('vacancyId') && <th>
                    <div className='filter__number_block'>
                      <input
                        name='id'
                        placeholder=' '
                        type='number'
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                      />
                      <label>ID</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('type') && <th>
                    <div className='multiselect__filter_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        inputValues={vacancyListInputValues}
                        options={filters.types}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='Тип вакансии'
                        name='type'
                        limit={limit}
                        reducer={reducerVacancyMultiselect}
                        resetPages={() => { }}
                        action={actionGetVacancies}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('regions') && <th>
                    <div className='reports__region_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        inputValues={vacancyListInputValues}
                        isShowPlaceholder={true}
                        options={filters.regions}
                        pageName='userReports'
                        placeholder='Регион'
                        resetPages={() => { }}
                        name='region'
                        limit={limit}
                        reducer={reducerVacancyMultiselect}
                        action={actionGetVacancies}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('areas') && <th>
                    <div className='reports__region_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        inputValues={vacancyListInputValues}
                        isShowPlaceholder={true}
                        options={filters.areas}
                        pageName='userReports'
                        placeholder='Область'
                        name='area'
                        limit={limit}
                        resetPages={() => { }}
                        reducer={reducerVacancyMultiselect}
                        action={actionGetVacancies}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('cities') && <th style={{ minWidth: '180px' }}>
                    <div className='filter__block'>
                      <input
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        autoComplete='off'
                        placeholder=' '
                        name='cities'
                        type='text'
                      />
                      <label>Город</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('subway') && <th style={{ minWidth: '180px' }}>
                    <div className='filter__block'>
                      <input
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        autoComplete='off'
                        placeholder=' '
                        name='subway'
                        type='text'
                      />
                      <label>Метро/Район</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('addresses') && <th style={{ minWidth: '280px' }}>
                    <div className='filter__block'>
                      <input
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        autoComplete='off'
                        placeholder=' '
                        name='addresses'
                        type='text'
                      />
                      <label>Адрес</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('merchs') && <th style={{ minWidth: '280px' }}>
                    <div className='filter__block'>
                      <input
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        autoComplete='off'
                        placeholder=' '
                        name='merchs'
                        type='text'
                      />
                      <label>Логин/Локация</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('vacancyName') && <th style={{ minWidth: '180px' }}>
                    <div className='filter__block'>
                      <input
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        autoComplete='off'
                        placeholder=' '
                        name='name'
                        type='text'
                      />
                      <label>Название вакансии</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('status') && <th>
                    <div className='reports__region_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        inputValues={vacancyListInputValues || []}
                        options={filters.statuses}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='Статус'
                        name='status'
                        limit={limit}
                        resetPages={() => { }}
                        reducer={reducerVacancyMultiselect}
                        action={actionGetVacancies}
                        activeOptions={vacancyListInputValues.status}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('projectName') && <th>
                    <div className='reports__region_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        inputValues={vacancyListInputValues || []}
                        options={filters.projects}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='Проект'
                        name='projects'
                        limit={limit}
                        resetPages={() => { }}
                        reducer={reducerVacancyMultiselect}
                        action={actionGetVacancies}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('routeNo') && <th>
                    <div className='filter__number_block'>
                      <input
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        autoComplete='off'
                        placeholder=' '
                        name='routes'
                        type='number'
                      />
                      <label>Маршрут</label>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('vsv') && <th>
                    <div className='multiselect__filter_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        inputValues={vacancyListInputValues}
                        options={filters.virtualSupervisors}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='ВСВ'
                        name='vsv'
                        limit={limit}
                        resetPages={() => { }}
                        reducer={reducerVacancyMultiselect}
                        action={actionGetVacancies}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('sv') && <th>
                    <div className='multiselect__filter_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        inputValues={vacancyListInputValues}
                        options={filters.supervisors}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='Супервайзер'
                        name='sv'
                        limit={limit}
                        resetPages={() => { }}
                        reducer={reducerVacancyMultiselect}
                        action={actionGetVacancies}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('schedule') && <th>
                    <div className='multiselect__filter_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        inputValues={vacancyListInputValues}
                        isShowPlaceholder={true}
                        pageName='userReports'
                        placeholder='График'
                        name='schedule'
                        limit={limit}
                        resetPages={() => { }}
                        reducer={reducerVacancyMultiselect}
                        options={filters.schedules}
                        action={actionGetVacancies}
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('salary') && <th>
                    <div className={styles.fromToFilter}>
                      <span>Зарплата</span>
                      <div className='filter__number_block'>
                        <input
                          onChange={(event) => handleFromFilter(event, 'salary')}
                          onKeyPress={handleKeyPress}
                          name='salary'
                          placeholder=' '
                          type='number'
                        />
                        <label>От</label>
                      </div>
                      <div className='filter__number_block'>
                        <input
                          onChange={(event) => handleToFilter(event, 'salary')}
                          onKeyPress={handleKeyPress}
                          name='salary'
                          placeholder=' '
                          type='number'
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('revenue') && <th>
                    <div className={styles.fromToFilter}>
                      <span>Выручка</span>
                      <div className='filter__number_block'>
                        <input
                          onChange={(event) => handleFromFilter(event, 'revenue')}
                          onKeyPress={handleKeyPress}
                          name='revenue'
                          placeholder=' '
                          type='number'
                        />
                        <label>От</label>
                      </div>
                      <div className='filter__number_block'>
                        <input
                          onChange={(event) => handleToFilter(event, 'revenue')}
                          onKeyPress={handleKeyPress}
                          name='revenue'
                          placeholder=' '
                          type='number'
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>}

                  {vacancyListSettings.includes('razm') && <th>
                    <div
                      className={clsx('filter__number_block', styles.checkin)}
                    >
                      <Select
                        options={booleanOptions}
                        propsChange={(event: { value: string, label: string }) =>
                          selectChange(event, "hasUrl")
                        }
                        placeholder='Размещена'
                        className='users__filter'
                        name="posted"
                      />
                    </div>
                  </th>}

                  {vacancyListSettings.includes('createdDate') && <th style={{ minWidth: '140px' }}>
                    <RangeDatePicker
                      setLoading={setIsPending}
                      reducer={reducerVacancyListInputValues}
                      defaultDateFrom={createDate.formattedDateFrom}
                      inputValues={vacancyListInputValues}
                      defaultDateTo={createDate.formattedDateTo}
                      setCurrentPage={setCurrentPage}
                      action={actionGetVacancies}
                      setStartPage={setStartPage}
                      limit={limit}
                      page={page}
                      placeholder='Дата создания'
                      pageName='vacancyList'
                      name='createDate'
                    />
                  </th>}

                  {vacancyListSettings.includes('modifiedDate') && <th style={{ minWidth: '140px' }}>
                    <RangeDatePicker
                      setLoading={setIsPending}
                      reducer={reducerVacancyListInputValues}
                      defaultDateFrom={modifiedDate.formattedDateFrom}
                      inputValues={vacancyListInputValues}
                      defaultDateTo={modifiedDate.formattedDateTo}
                      setCurrentPage={setCurrentPage}
                      action={actionGetVacancies}
                      setStartPage={setStartPage}
                      limit={limit}
                      page={page}
                      placeholder='Дата изменения'
                      pageName='vacancyList'
                      name='modifiedDate'
                    />
                  </th>}
                </tr>
              </thead>

              <tbody>
                {data && data?.map((el: IVacancyListOptions, index: number) => {
                  const salaryDiff = Object.keys(el.type?.value)[0] === 'PARTIAL_ROUTE' && (Object.keys(el.status?.value)[0] === 'REPLACEMENT' || Object.keys(el.status?.value)[0] === 'LINGERING_VACANT' || Object.keys(el.status?.value)[0] === 'UNPROFITABLE');
                  const styleClassName = `relative__elem ${el?.isChanged ? styles.changed : ''}`;
                  return (
                    <tr className='active__link_tr' key={index}>
                      <td>
                        {(claims.includes('admin') || claims.includes('recruiting:vacancy:export') || claims.includes('recruiting:vacancy:edit')) &&
                          <input
                            onChange={() => handleRowCheckboxChange(el)}
                            checked={
                              (isCheckedRows && isCheckedRows[el.vacancy.value.id]) || false
                            }
                            className='relative__elem'
                            type='checkbox'
                          />}
                      </td>
                      {vacancyListSettings.includes('vacancyId') && <td>
                        <span className='relative__elem'>{el?.vacancy?.value?.id}</span>
                      </td>}
                      {vacancyListSettings.includes('type') && <td>
                        <span className={styleClassName}>
                          {Object.values(el.type?.value).toString()}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('regions') && <td>
                        <span className={styleClassName}>
                          {el?.regions?.valueAll?.map((item: { name: string }, index: number) => (
                            <span key={item.name}>
                              {el?.regions?.valueAll?.length > 1 ? index === el?.regions?.valueAll?.length - 1 ? item.name : `${item.name}, ` : item.name}
                            </span>
                          ))}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('areas') && <td>
                        <span className={styleClassName}>
                          {el?.areas?.valueAll?.map((item: { name: string }, index: number) => (
                            <span key={item.name}>
                              {el?.areas?.valueAll?.length > 1 ? index === el?.areas?.valueAll?.length - 1 ? item.name : `${item.name}, ` : item.name}
                            </span>
                          ))}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('cities') && <td>
                        <span className={styleClassName}>
                          {el?.cities?.valueAll ? el?.cities?.valueAll?.join(', ') : ''}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('subway') && <td>
                        <span className={styleClassName}>
                          {el?.subway?.value ? el?.subway?.value : ''}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('addresses') && <td>
                        <span className={styleClassName}>
                          {el?.addresses?.valueAll !== null && el?.addresses?.valueAll?.map((item: string, index: number) => (
                            <span key={index} className='relative__elem_span'>
                              {el?.addresses?.valueAll?.length > 1 ? index === el?.addresses?.valueAll?.length - 1 ? item : `${item}; ` : item}
                            </span>
                          ))}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('merchs') && <td>
                        <span className={styleClassName}>
                          {el?.merchs?.valueAll ? el?.merchs?.valueAll?.join(', ') : ''}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('vacancyName') && <td>
                        <span className={styleClassName}>{el?.name.value}</span>
                      </td>}

                      {vacancyListSettings.includes('status') && <td>
                        <span className={styleClassName}>
                          {Object.values(el.status?.value).toString()}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('projectName') && <td>
                        {el.projects?.value &&
                          el.projects?.value.map((item: { id: number, name: string }, index: number) => (
                            <span key={index} className={styleClassName}>
                              {item && item.name}{index !== el.projects.value.length - 1 && ', '}
                            </span>
                          ))}
                      </td>}

                      {vacancyListSettings.includes('routeNo') && <td>
                        <span className={styleClassName}>
                          {el?.routes?.valueAll ? el?.routes?.valueAll?.join(', ') : ''}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('vsv') && <td>
                        {el.virtualSupervisors?.valueAll &&
                          el.virtualSupervisors?.valueAll.map((item: { employee: { id: number, name: string }, phone?: string }, index: number) => (
                            <span key={index} className={styleClassName}>
                              {item.employee && item.employee.name.slice(0, -1)}{index !== el.virtualSupervisors.valueAll.length - 1 && ', '}
                            </span>
                          ))}
                      </td>}
                      {vacancyListSettings.includes('sv') && <td>
                        {el.supervisors?.valueAll &&
                          el.supervisors?.valueAll.map((item: { employee: { id: number, name: string }, phone?: string }, index: number) => (
                            <span key={index} className={styleClassName}>
                              {item.employee && item.employee.name.slice(0, -1)}{index !== el.supervisors.valueAll.length - 1 && ', '}
                            </span>
                          ))}
                      </td>}

                      {vacancyListSettings.includes('schedule') && <td>
                        {el.schedule?.valueAll && (
                          <span className={styleClassName}>
                            {el.schedule.valueAll.length === 1 ? (
                              Object.values(el.schedule.valueAll[0]).toString()
                            ) : (
                              el.schedule.valueAll.map((item: { [key: string]: string }, index: number) => (
                                <span key={index}>
                                  {Object.values(item).toString()}
                                  {index !== el.schedule.valueAll.length - 1 && ', '}
                                </span>
                              ))
                            )}
                          </span>
                        )}
                      </td>}

                      {vacancyListSettings.includes('salary') && <td>
                        <span className={styleClassName}>
                          {(el.salary.value || 0) + (el.salary.ext || 0)}
                          {(salaryDiff && el.salary.changed) && <span className={clsx((salaryDiff && el.salary.changed) && styles.iconChanged)}>!</span>}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('revenue') && <td>
                        <span className={styleClassName}>
                          {(el?.revenue?.value || 0) + (el?.revenue?.ext || 0)}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('razm') && <td>
                        <span className={styleClassName}>
                          {el?.url?.value ? 'Да' : 'Нет'}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('createdDate') && <td>
                        <span className={styleClassName}>
                          {formatDateWithDots(el?.createdDate?.value)}
                        </span>
                      </td>}

                      {vacancyListSettings.includes('modifiedDate') && <td>
                        <span className={styleClassName}>
                          {el?.modifiedDate && formatDateWithDots(el?.modifiedDate.value)}
                        </span>
                      </td>}

                      <td className='invisible__reports_cell'></td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <span>
              {((data && data !== null) && !data.length) && <div className='noData'>Нет данных</div>}
            </span>
          </div>

          <div className='pagination'>
            <div className='pagination__count'>Всего: {count}</div>
            <div className='pagination__str'>
              <span>Отображать строки</span>
              <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
            </div>
            <Pagination
              setCurrentPage={setCurrentPage}
              setStartPage={setStartPage}
              handleChange={handleChange}
              count={count}
              currentPage={currentPage}
              startPage={startPage}
              limit={actualLimit}
              pageName='userReports'
            />
          </div>
        </div>
      </div>
      <button className={styles.accept__btn}>Пропустить выбор</button>
    </>
  )
};

export default ReinstateAnEmployeeSection;